import { Button as CarbonButton } from '@carbon/react';
import type { ComponentProps, ReactNode } from 'react';
import type { IconComponent } from '../../types';

type CarbonButtonProps = ComponentProps<typeof CarbonButton>;

export type CdButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'ghost' | 'danger';
export type CdButtonSize = 'sm' | 'md' | 'lg' | 'xl';

export interface CdButtonProps extends Omit<
  CarbonButtonProps,
  'kind' | 'size' | 'renderIcon' | 'children'
> {
  /** Visual style. `primary` = PermiOne rust CTA, `tertiary` = brand-blue outline. */
  variant?: CdButtonVariant;
  size?: CdButtonSize;
  /** Trailing icon (Carbon convention). */
  icon?: IconComponent;
  children: ReactNode;
}

/** Text button. For icon-only actions use `IconButton`. */
export const CdButton = ({
  variant = 'primary',
  size = 'md',
  icon,
  children,
  ...rest
}: CdButtonProps) => {
  return (
    <CarbonButton kind={variant} size={size} renderIcon={icon} {...rest}>
      {children}
    </CarbonButton>
  );
};
